export default {
  title: 'Items',
};
